var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOfflineOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66094 7.1582C1.9332 7.73633 0.625 9.10547 0.625 11.25C0.625 13.8281 2.73438 15.625 5.3125 15.625H12.5145",
    stroke: "currentColor",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2742 14.7555C18.9547 14.1914 19.375 13.3441 19.375 12.1875C19.375 9.85078 17.3047 8.8375 15.625 8.75C15.2777 5.25234 12.8516 3.125 10 3.125C8.97813 3.125 8.09414 3.3957 7.35938 3.83359",
    stroke: "currentColor",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L2.5 2.5",
    stroke: "currentColor",
    strokeWidth: 1.11111,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOfflineOutline);
export default __webpack_public_path__ + "static/media/cloud_offline_outline.4ae78297533c19547f01cc9f9e8625d6.svg";
export { ForwardRef as ReactComponent };